export const decoratedData = data => {
  const projectsByYear = {}

  data?.Implementer?.projects?.forEach(project => {
    if (!(project.year in projectsByYear)) {
      projectsByYear[project.year] = [project]
    } else {
      projectsByYear[project.year].push(project)
    }
  })

  const result = Object.keys(projectsByYear).map(key => {
    const row = { year: key, private: 0, public: 0, own: 0, total: 0 }

    projectsByYear[key]?.forEach(project => {
      project.financing?.forEach(el => {
        row[el.type?.toLowerCase()] += el.amount
        row.total += el.amount
      })
    })

    return row
  })
  const submissionYears = data?.Implementer?.submissions
    ?.filter(s => s.state === "PROJECT" && s.startDate && s.endDate)
    ?.flatMap(s => {
      const start = new Date(s.startDate).getFullYear()
      const end = new Date(s.endDate).getFullYear()

      const years = []
      for (let y = start; y <= end; y++) {
        years.push(String(y))
      }
      return years
    }) ?? []

  const uniqueSubmissionYears = [...new Set(submissionYears)]

  uniqueSubmissionYears.forEach(year => {
    if (!result.find(r => r.year === year)) {
      result.push({
        year,
        private: 0,
        public: 0,
        own: 0,
        total: 0
      })
    }
  })
  return result
}